import React from 'react';
import './style.scss'
import { useStore } from "../../store/store"
import { t } from '@web-solutions/module-localization';
import { Typography } from 'src/onboarding/components/typography-voery/Typography';

const Footer = () => {
    const setPage = useStore((state) => state.setPage);

    return (
      <div className={'container'}>
        <Typography variant='callout-medium' className="contact-us">{t('onboarding.personalPlan.footer.contactUs')}</Typography>
        <Typography variant='callout-medium' className="address">{t('onboarding.personalPlan.footer.adress')}</Typography>
        <div className="links">
          <span className='links_top'>
            <a onClick={() => setPage("privacy-policy")}>{t('onboarding.personalPlan.footer.privacy')}</a>
            <a onClick={() => setPage("terms-of-use")}>{t('onboarding.personalPlan.footer.term')}</a>
          </span>
        </div>
      </div>
    );
}

export default Footer;
